<template>
    <PrintBookMobileNav v-if="hermesAPIConfig.client === 'print-book'" />
    <DefaultMobileNav v-else />
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { inHelpSection, inProfileSection, inAdministrationSection } from "@/helpers/section";
import DefaultMobileNav from "@/components/Hermes/Header/DefaultMobileNav/DefaultMobileNav.vue";
import PrintBookMobileNav from "@/components/Hermes/Header/CustomMobileNav/PrintBookMobileNav/PrintBookMobileNav.vue";

export default {
    name: "MobileNav",
    components: {PrintBookMobileNav, DefaultMobileNav},
    computed: {
        ...mapGetters("publishers", {
            publishers: "publishers",
        }),
        ...mapGetters("sideBarMenu", [
            "isMobileNavSectionActive",
        ]),
        ...mapGetters("config", {
            hermesAPIConfig: "hermesAPI",
        }),
        ...mapGetters("user", {
            isUserLogged: "isLogged",
            user: "user",
        }),
        inHelpSection() {
            return inHelpSection(this.$route.name);
        },
        inProfileSection() {
            return inProfileSection(this.$route.name);
        },
        inAdministrationSection() {
            return inAdministrationSection(this.$route.name);
        },
    },
    methods: {
        ...mapActions("sideBarMenu", {
            hideSideBar: "hide",
        }),
    },
};
</script>

<style scoped>

</style>